import React, { useEffect } from 'react';
import { MailOutlined, ReloadOutlined } from '@ant-design/icons';
import { Alert, Button, Image, Space, Typography } from 'antd';
import { useSelector } from 'react-redux';
import axios from 'axios';

const importErrors = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
];

const isProduction = process.env.NODE_ENV === 'production';

function Fallback({ error }) {
  const me = useSelector((state) => state.auth);

  const isImportError = importErrors.some((importError) => error?.message?.includes(importError));

  useEffect(() => {
    if (isProduction && error && !isImportError) {
      axios.post('/send-logs', {
        location: window.location.href,
        message: error.message,
        stack: error.stack,
        metaData: { user: me?.id },
      });
    }
  }, [error, isImportError, me]);

  if (error && isImportError) {
    window.location.reload();
    return <></>;
  }

  return (
    <div style={{ height: '100vh' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Space direction="vertical" size="middle">
          <div style={{ maxWidth: 500, position: 'relative' }}>
            <div>
              <img src="/logo.png" width={150} style={{ position: 'absolute', top: -40 }} />
            </div>
            <Typography.Title
              level={5}
              style={{ marginBottom: 0 }}
            >{`Uh-Oh! Looks like you've encountered an error.`}</Typography.Title>
            <Typography.Paragraph type="secondary" style={{ marginBottom: 0 }}>
              {`If you'd like to help us improve this app, please send us an email with the following error message:`}
            </Typography.Paragraph>
          </div>
          {error && error.message && <Alert message={error.message} type="error" />}

          <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              icon={<ReloadOutlined />}
              variant="contained"
              onClick={() => window.location.reload()}
            >
              Reload
            </Button>
            <Button
              icon={<MailOutlined />}
              href="https://whatsform.help.center/contact"
              type="primary"
              color="danger"
            >
              Contact us
            </Button>
          </Space>
        </Space>
      </div>
    </div>
  );
}

export default Fallback;
